export const rewardRedemption = {
  loyaltyRedemption: "Loyalty Redemption",
  rewardRedemption: "Reward Redemption",
  search: "Search",
  from: "From",
  to: "To",
  advanceFilter: "Advance Filter",
  trackingNumber: "TRACKING NUMBER",
  trackingLink: "TRACKING Link",
  status: "Status",
  selectStatus: "SELECT STATUS",
  all: "ALL",
  pending: "PENDING",
  completed: "COMPLETED",
  selectType: "SELECT TYPE",
  normal: "NORMAL",
  cash: "CASH",
  username: "USERNAME",
  reward: "REWARD",
  quantity: "QUANTITY",
  rewardType: "REWARD TYPE",
  address: "ADDRESS",
  dateCreated: "DATE CREATED",
  ship: "Ship",
  edit: "Edit",
  close: "Close",
  submit: "Submit",
  approved: "APPROVED",
  rejected: "REJECTED",
  waitForApprove: "WAIT_FOR_APPROVED",
  rewardShipment: " Reward Shipment",
  approvedBy: "APPROVED BY",
  approvedAt: "APPROVED DATE",
  fortuneWheel: "FORTUNE_WHEEL"
};
